var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.993 0C3.129 0 0 3.136 0 7C0 10.864 3.129 14 6.993 14C10.864 14 14 10.864 14 7C14 3.136 10.864 0 6.993 0ZM11.844 4.2H9.779C9.555 3.325 9.233 2.485 8.813 1.708C10.101 2.149 11.172 3.045 11.844 4.2ZM7 1.428C7.581 2.268 8.036 3.199 8.337 4.2H5.663C5.964 3.199 6.419 2.268 7 1.428ZM1.582 8.4C1.47 7.952 1.4 7.483 1.4 7C1.4 6.517 1.47 6.048 1.582 5.6H3.948C3.892 6.062 3.85 6.524 3.85 7C3.85 7.476 3.892 7.938 3.948 8.4H1.582ZM2.156 9.8H4.221C4.445 10.675 4.767 11.515 5.187 12.292C3.899 11.851 2.828 10.962 2.156 9.8ZM4.221 4.2H2.156C2.828 3.038 3.899 2.149 5.187 1.708C4.767 2.485 4.445 3.325 4.221 4.2ZM7 12.572C6.419 11.732 5.964 10.801 5.663 9.8H8.337C8.036 10.801 7.581 11.732 7 12.572ZM8.638 8.4H5.362C5.299 7.938 5.25 7.476 5.25 7C5.25 6.524 5.299 6.055 5.362 5.6H8.638C8.701 6.055 8.75 6.524 8.75 7C8.75 7.476 8.701 7.938 8.638 8.4ZM8.813 12.292C9.233 11.515 9.555 10.675 9.779 9.8H11.844C11.172 10.955 10.101 11.851 8.813 12.292ZM10.052 8.4C10.108 7.938 10.15 7.476 10.15 7C10.15 6.524 10.108 6.062 10.052 5.6H12.418C12.53 6.048 12.6 6.517 12.6 7C12.6 7.483 12.53 7.952 12.418 8.4H10.052Z",
    fill: "#959CA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFavicon);
export default __webpack_public_path__ + "static/media/no_favicon.cce1c00b20560565832df60a4c8b7ab3.svg";
export { ForwardRef as ReactComponent };